export default "__VITE_ASSET__D$$73y1w__"